export default "__VITE_ASSET__02970bd8__"